import React, {Component} from "react"
import PropTypes from "prop-types"

class FormSearchUsers extends Component {
    state = {
        term: ''
    }

    _delaySearch = null

    componentDidUpdate(prevProps, prevState) {
        if (prevState.term !== this.state.term) {
            this._triggerSearch()
        }
    }

    _handleChangeTerm = (e) => {
        const {value} = e.target

        this.setState({
            term: value
        })
    }

    _triggerSearch = () => {
        if (this._delaySearch) {
            clearTimeout(this._delaySearch)
        }

        this._delaySearch = setTimeout(() => {
            const {term} = this.state

            this.props.onChangeQuery({term})
        }, 500)
    }

    render() {
        const {term} = this.state

        return (
            <form className="FormSearchUsers">
                <div className="form-group">
                    <input
                        placeholder="Search by email, IP:(x.x.x.x), id:(xxx), plan:(pro)"
                        className="form-control"
                        onChange={this._handleChangeTerm}
                        value={term} type="text"/>
                </div>
            </form>
        )
    }
}

FormSearchUsers.propTypes = {
    onChangeQuery: PropTypes.func.isRequired
}

export default FormSearchUsers



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/users/FormSearchUsers/FormSearchUsers.js